import ReviewCardView from './review-card-view'

export default ReviewCardView
